<template>
  <v-container fluid>
    <v-row class="pb-3">
      <v-col cols="12" md="4">
        <v-text-field
          v-model="filterName"
          label="Filter by Name"
          dense
          outlined
          clearable
          hide-details
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field
          v-model="filterSurname"
          label="Filter by Surname"
          dense
          outlined
          clearable
          hide-details
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field
          v-model="filterGroupLabel"
          label="Filter by Group"
          dense
          outlined
          clearable
          hide-details
        ></v-text-field>
      </v-col>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="filteredParticipants"
      class="elevation-1"
    >
      <template v-slot:item.groupLabel="{ item }">
        <v-text-field
          :value="item.groupLabel"
          dense
          outlined
          hide-details
          @input="updateGroupLabel(item.id, $event)"
        ></v-text-field>
      </template>
      <template v-slot:item.assignedRooms="{ item }">
        <v-chip
          v-for="service in getAssignedServices(item.id)"
          :key="service.id"
          small
          class="mr-1"
        >
          {{ service.serviceName }} ({{ service.startDate | formatDate }})
        </v-chip>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-menu offset-y :close-on-content-click="false">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" dark v-bind="attrs" v-on="on" small>
              Assign Service
            </v-btn>
          </template>
          <v-card class="pa-4" min-width="300">
            <gt-multi-select
              :value="getAssignedServiceIds(item.id)"
              :items="serviceOptions"
              item-text="displayText"
              item-value="id"
              label="Assign Services"
              dense
              outlined
              @input="
                (selectedIds) => updateServiceAssignments(item.id, selectedIds)
              "
            />
          </v-card>
        </v-menu>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import GtMultiSelect from "../../shared/GtMultiSelect.vue";

export default {
  name: "RoomingListByParticipant",
  components: {
    GtMultiSelect,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    participants: {
      type: Array,
      required: true,
    },
    assignments: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      filterName: "",
      filterSurname: "",
      filterGroupLabel: "",
      headers: [
        { text: "Name", value: "name" },
        { text: "Surname", value: "surname" },
        { text: "Group", value: "groupLabel", width: "200px" },
        { text: "Assigned Services", value: "assignedRooms" },
        { text: "Actions", value: "actions", sortable: false },
      ],
    };
  },
  computed: {
    filteredParticipants() {
      let filtered = this.participants;

      // Filter by name
      if (this.filterName) {
        const nameFilter = this.filterName.toLowerCase();
        filtered = filtered.filter(
          (p) => p.name && p.name.toLowerCase().includes(nameFilter)
        );
      }

      // Filter by surname
      if (this.filterSurname) {
        const surnameFilter = this.filterSurname.toLowerCase();
        filtered = filtered.filter(
          (p) => p.surname && p.surname.toLowerCase().includes(surnameFilter)
        );
      }

      // Filter by group label
      if (this.filterGroupLabel) {
        const groupFilter = this.filterGroupLabel.toLowerCase();
        filtered = filtered.filter(
          (p) =>
            p.groupLabel && p.groupLabel.toLowerCase().includes(groupFilter)
        );
      }

      return filtered;
    },
    serviceOptions() {
      // Format services with display text for the multiselect
      return this.items.map((item) => ({
        ...item,
        displayText: `${item.serviceName} - ${this.formatDate(item.startDate)}`,
      }));
    },
  },
  methods: {
    formatDate(date) {
      // Use the global formatDate filter
      if (this.$options.filters && this.$options.filters.formatDate) {
        return this.$options.filters.formatDate(date);
      }
      // Fallback formatting if filter not available
      if (!date) return "";
      const d = new Date(date);
      return d.toLocaleDateString();
    },
    getAssignedServiceIds(participantId) {
      // Get array of service IDs assigned to this participant
      return this.assignments[participantId] || [];
    },
    getAssignedServices(participantId) {
      // Directly access participant's assigned service IDs
      const serviceIds = this.assignments[participantId] || [];
      return this.items.filter((item) => serviceIds.includes(item.id));
    },
    availableServices(participantId) {
      // Return all items that this participant is NOT assigned to
      // You might want to filter by date or other criteria as well
      const assignedServiceIds = this.assignments[participantId] || [];
      return this.items.filter((item) => !assignedServiceIds.includes(item.id));
    },
    updateServiceAssignments(participantId, selectedServiceIds) {
      // Update the participant's assignments array with the new selection
      const newAssignments = {
        ...this.assignments,
        [participantId]: selectedServiceIds || [],
      };
      this.$emit("update:assignments", newAssignments);
    },
    updateGroupLabel(participantId, groupLabel) {
      // Emit event to update groupLabel in parent component
      this.$emit("update:groupLabel", { participantId, groupLabel });
    },
    assignService(serviceId, participantId) {
      // Add serviceId to participant's assignments array
      const currentServices = this.assignments[participantId] || [];
      if (!currentServices.includes(serviceId)) {
        const newAssignments = {
          ...this.assignments,
          [participantId]: [...currentServices, serviceId],
        };
        this.$emit("update:assignments", newAssignments);
      }
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/rooming-list/RoomingListByParticipant.vue